import React from 'react';

import { Provider } from 'react-redux';

import store from 'store/store';

export const withReduxStore = (WrappedComponent) => {
  function WithReduxStore(props) {
    return (
      <Provider store={store}>
        <WrappedComponent {...props} />
      </Provider>
    );
  }
  WithReduxStore.displayName = `withReduxStore(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithReduxStore;
};
